import borderedIcon from './bordered'

export default {
  borderedIcon
}



// WEBPACK FOOTER //
// ./src/styles/icons/index.js